/**
 * Escape a value for safe interpolation into SQL strings.
 * Escapes backslashes, doubles single quotes, strips null bytes.
 */
export const escapeSql = (value) => {
  const str = String(value);
  return str
    .replace(/\\/g, '\\\\')
    .replace(/'/g, "''")
    .replace(/\0/g, '');
};
